import styled from '@emotion/styled/macro';

import { Button } from 'components/buttons';

export const ModalRoot = styled.div(() => ({
  outline: 'none',
}));

export const PanelContent = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 16,
  maxWidth: 420,
  padding: '0 12px 10px 10px',
}));

export const Delimeter = styled.div((props) => ({
  borderBottom: `1px solid ${props.theme.colors.container.primary}`,
  width: '100%',
}));

export const Buttons = styled.div(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: 16,
}));

export const ControlsWrapper = styled.div(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 8,
}));

export const CloseButton = styled(Button)(() => ({
  padding: '8px',
  minWidth: 'auto',
}));

export const BeneficiarySection = styled.div((props) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: 16,
  backgroundColor: props.theme.colors.pageWrapper,
  borderRadius: 8,
}));

export const BeneficiaryHeader = styled.div((props) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}));

export const BeneficiaryTitle = styled.div((props) => ({
  fontSize: 14,
  fontWeight: 600,
  fontFamily: props.theme.fonts.primary,
}));

export const BeneficiaryActions = styled.div(() => ({
  display: 'flex',
  gap: 8,
  width: '100%',
  marginTop: 8,
}));

export const RecordButton = styled(Button)<{ inside?: boolean }>((props) => ({
  textTransform: 'uppercase',
  marginLeft: props.inside ? 0 : 9,
  marginTop: props.inside ? 0 : 12,
}));
